import { DateFields, Services } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import noData from '@/components/misc/noData'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderNoData(h, value, icon) {
  return h(
    noData,
    {
      props: {
        icon,
        value: this.getTranslate(`${Services.tokens}.labels.noData.${value}`),
        label: this.getTranslate(`${Services.tokens}.labels.${value}`)
      }
    }
  )
}
function renderDescription(h) {
  if (this.value.description) {
    return h(
      sticker,
      {
        props: {
          value: this.value.description,
          label: this.getTranslate(`${Services.tokens}.labels.description`),
          copy: true,
          to: this.$_to
        }
      }
    )
  }

  return renderNoData.call(this, h, 'description')
}
function renderId(h) {
  if (this.viewport.size.width > 720) {
    if (this.hasPermissions) {
      return h(
        sticker,
        {
          props: {
            value: this.value.id,
            label: this.getTranslate(`${Services.tokens}.labels.id`),
            copy: true,
            service: Services.tokens,
            pathToTitle: 'id'
          }
        }
      )
    }

    return h('div')
  }
}
function renderOwner(h) {
  if (this.hasOwner) {
    if (this.viewport.size.width > 600) {
      return h(
        owner,
        {
          props: {
            value: this.value
          }
        }
      )
    }
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.tokens}-item__info`]: true,
        [`${Services.tokens}-item__info--admin`]: this.hasOwner
      }
    },
    [
      renderDescription.call(this, h),
      renderId.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}

function renderActions(h) {
  if (this.hasPermissions) {
    return h(
      actions,
      {
        props: {
          value: this.value,
          service: Services.tokens
        }
      }
    )
  }

  return h('div')
}

function renderExpiredAt(h) {
  if (this.viewport.size.width > 600) {
    if (this.value.expiredAt) {
      return h(
        date,
        {
          props: {
            value: this.value,
            field: DateFields.expiredAt
          }
        }
      )
    }

    return renderNoData.call(this, h, DateFields.expiredAt, icons.event_busy)
  }
}
function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item': true,
        [`${Services.tokens}-item`]: true,
        'hover-parent hover-parent--opacity': this.viewport.breakpoint.mdUp
      }
    },
    [
      renderInfo.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h),
      renderExpiredAt.call(this, h)
    ]
  )
}
